"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectedNavigation = exports.Navigation = void 0;
const react_1 = __importStar(require("react"));
const spa_core_1 = require("@episerver/spa-core");
require("./Navigation.scss");
const LanguageSelector_1 = __importDefault(require("./LanguageSelector"));
const react_redux_1 = require("react-redux");
const NavigationTree_1 = __importDefault(require("app/Components/NavigationTree/NavigationTree"));
const foundation_settings_1 = require("@episerver/foundation-settings");
const just_debounce_it_1 = __importDefault(require("just-debounce-it"));
const framer_motion_1 = require("framer-motion");
const Header_1 = __importDefault(require("./Header"));
const react_router_dom_1 = require("react-router-dom");
const Shareticker_1 = __importDefault(require("app/Components/Common/Shareticker/Shareticker"));
const NavigationSearch_1 = __importDefault(require("../Common/Search/NavigationSearch"));
const Navigation = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const ctx = (0, spa_core_1.useEpiserver)();
    const navi = (0, react_1.useRef)(null);
    const tree = (0, react_1.useRef)(null);
    const level1 = (0, react_1.useRef)(null);
    const bottomSearchBtn = (0, react_1.useRef)(null);
    const settingsService = (0, foundation_settings_1.useSettings)();
    const [layoutSettings, setLayoutSettings] = (0, react_1.useState)(settingsService.getContainerOnServer('LayoutSettings'));
    const [navigationSettings, setNavigationSettings] = (0, react_1.useState)(settingsService.getContainerOnServer('Navigation'));
    const [labelSettings, setLabelSettings] = (0, react_1.useState)(settingsService.getContainerOnServer('LabelSettings'));
    const [mainpage, setMainpage] = (0, react_1.useState)();
    const location = (0, react_router_dom_1.useLocation)();
    // Gets structure starting from where we landed - for ssr
    const landedTree = settingsService.getContainerOnServer('CurrentNavigation');
    // Path of landed page - for ssr
    const landedPath = ctx.serviceContainer.getService('ServerContext').getProp('path');
    // levels to render
    const [navLevels, setNavLevels] = (0, react_1.useState)([]);
    const [levelRemoved, setLevelRemoved] = (0, react_1.useState)(false);
    // ssr levelprops - for desktop
    const defaultLevelProps = {
        url: landedPath,
        orgUrl: landedPath,
        renderedLevel: false,
        tree: landedTree,
        default: true
    };
    const [level, setLevel] = (0, react_1.useState)(defaultLevelProps);
    //mobile helper
    const isMobile = () => { return window.innerWidth < 860; };
    const maxLevelsInMobile = () => {
        var _a;
        let val = ((_a = layoutSettings.navLevelsMobile) === null || _a === void 0 ? void 0 : _a.value) ? layoutSettings.navLevelsMobile.value : layoutSettings.navLevelsMobile;
        return val > 0 ? val - 1 : 3;
    };
    if (!navigationSettings) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    const transition = { ease: 'linear', duration: 0.3 };
    const scrollNav = () => {
        if (window.innerWidth > 859.99) {
            window.scrollBy({
                behavior: 'smooth',
                left: 0,
                top: window.scrollY + 200
            });
        }
        else {
            const el = document.querySelector('.main');
            el.scrollBy({
                behavior: 'smooth',
                left: 0,
                top: el.scrollTop + 200
            });
        }
    };
    /**
     * Builds navigation levels based on current situation.
     * Used when clicking nav level open or when opening mobile menu
     *
     * @param mobile:boolean
     */
    function buildNav(mobile) {
        if (!level.default) {
            //for results
            const updatedNavLevels = [];
            // for iteration
            const pathArray = level.url[level.url.length - 1] === '/' ? level.url.substring(1, level.url.length - 1).split('/') : level.url.substring(1).split('/');
            let needle = '/';
            pathArray[0] === 'fi' && pathArray.shift() && (needle = '/fi/');
            // subresult
            let newItem;
            // structure to iterate. 
            let navigation = level.tree.items || level.tree.subItems;
            // helper to identify if we found item from first loop or from the second, 
            // it's for finding correct items if we have redirection so that two levels has same url => showing the latter.
            let notFirstLevel = true;
            // level number for loop
            let navLevel = 1;
            pathArray.forEach((item) => {
                needle = needle + item + '/';
                // to highlight path to active page
                const highlightedpage = needle + pathArray[navLevel] + '/';
                // find form first level of array
                newItem = navigation.find(function (item) { return item.linkUrl === needle || item.linkUrl == needle.substring(0, needle.length - 1); });
                if (newItem !== undefined && newItem.subItems.length > 0 && (!mobile || navLevel <= maxLevelsInMobile())) {
                    //const scrollLevel = navLevel
                    updatedNavLevels.push(react_1.default.createElement(framer_motion_1.motion.div, { initial: { transform: 'translateX(0%)' }, animate: { transform: `translateX(${navLevel * 100}%)` }, onAnimationComplete: () => adjustHeight(), transition: transition, key: newItem.guid, "data-level": navLevel.toString(), className: 'col w-100 h-100 position-absolute top-0' },
                        react_1.default.createElement(NavigationTree_1.default, { labels: labelSettings, closeNav: closeNav, openLevel: openLevel, navigationTree: newItem.subItems, navigationLevel: notFirstLevel, navigationLevelAsNum: navLevel, backToMenu: backToMenu, showBackToMenu: false, sectionHeading: newItem.linkLabel, mobile: mobile, maxLevelsInMobile: maxLevelsInMobile(), currentUrl: level.orgUrl, needle: highlightedpage, adjustHeight: adjustHeight, removeLastLevel: removeLastLevel }),
                        react_1.default.createElement("button", { onClick: scrollNav, className: 'position-absolute border-0 scroll-icon align-items-center justify-content-center' },
                            react_1.default.createElement("span", { className: 'visually-hidden' },
                                react_1.default.createElement(spa_core_1.Components.Property, { iContent: labelSettings, field: 'scrollText' })),
                            react_1.default.createElement("span", { className: 'icon-nav-caret', "aria-hidden": true }))));
                    // going to sub items to make sure we don't have same url also on next level
                    navigation = newItem.subItems;
                    navLevel = navLevel + 1;
                    if (level.renderedLevel) {
                        newItem = navigation.find(function (item) { return item.linkUrl === needle || item.linkUrl == needle.substring(0, needle.length - 1); });
                        if (newItem !== undefined && newItem.subItems.length > 0)
                            updatedNavLevels.push(react_1.default.createElement(framer_motion_1.motion.div, { initial: { transform: 'translateX(0%)' }, animate: { transform: `translateX(${navLevel * 100}%)` }, onAnimationComplete: () => adjustHeight(), transition: transition, key: newItem.guid, "data-level": navLevel.toString(), className: 'col w-100 h-100 position-absolute top-0' },
                                react_1.default.createElement(NavigationTree_1.default, { labels: labelSettings, closeNav: closeNav, openLevel: openLevel, navigationTree: newItem.subItems, navigationLevel: notFirstLevel, navigationLevelAsNum: navLevel, backToMenu: backToMenu, showBackToMenu: false, sectionHeading: newItem.linkLabel, mobile: mobile, maxLevelsInMobile: maxLevelsInMobile(), currentUrl: level.orgUrl, needle: highlightedpage, adjustHeight: adjustHeight, removeLastLevel: removeLastLevel }),
                                react_1.default.createElement("button", { onClick: scrollNav, className: 'position-absolute border-0 scroll-icon align-items-center justify-content-center' },
                                    react_1.default.createElement("span", { className: 'visually-hidden' },
                                        react_1.default.createElement(spa_core_1.Components.Property, { iContent: labelSettings, field: 'scrollText' })),
                                    react_1.default.createElement("span", { className: 'icon-nav-caret', "aria-hidden": true }))));
                    }
                }
            });
            setNavLevels(updatedNavLevels);
        }
    }
    const findSubLevel = (url, newTree) => {
        let parsedLevel;
        if (url[url.length - 1] === '/') {
            parsedLevel = url.substring(1, url.length - 1);
        }
        else {
            parsedLevel = url.substring(1);
            url = `${url}/`;
        }
        const pathArray = parsedLevel.toString().split('/');
        let needle = '/';
        if (pathArray[0] === 'fi') {
            pathArray.shift();
            needle = '/fi/';
        }
        let newItem;
        let navigation = newTree.items;
        let result = newTree;
        let stop = false;
        // Debug for disappearing navigation
        if (!navigation || navigation.length < 1 || !url || url === '') {
            console.info(`Finding sublevel for ${url}. Source is ${JSON.stringify(navigation)}`);
        }
        pathArray.forEach((item, index) => {
            if (!stop) {
                needle = needle + item + '/';
                newItem = navigation.find(function (item) { return item.linkUrl === needle || item.linkUrl == needle.substring(0, needle.length - 1); });
                if (newItem !== undefined) {
                    if (newItem.linkUrl === url && index === 0) {
                        stop = true;
                    }
                    else {
                        // going to sub items to check if this is right level
                        if (newItem.subItems.length > 0) {
                            navigation = newItem.subItems;
                            const subItem = navigation.find(function (item) { return item.linkUrl === url || item.linkUrl == url.substring(0, url.length - 1); });
                            if (subItem !== undefined) {
                                result = newItem;
                                result.isSubMenu = true;
                                stop = true;
                                // if this is true, we can stop... url will not be there. Returning previous level.	
                            }
                            else if (index === pathArray.length - 2) {
                                stop = true;
                                result.isSubMenu = true;
                            }
                        }
                        else {
                            stop = true;
                            result.isSubMenu = true;
                        }
                    }
                }
                if (!stop && newItem)
                    result = newItem;
            }
        });
        return result;
    };
    // For Mobile
    const toggleNav = (g) => {
        g ? document.body.style.overflow = 'hidden' : document.body.style.overflow = '';
        if (props.dispatch)
            props.dispatch({ type: 'ApplicationStates/SetNavOpen', navOpen: g });
    };
    // Closes nav on mouse leave. 1 sec delay.
    const debouncedCloseNav = (0, just_debounce_it_1.default)(() => {
        if (navLevels.length > 0) {
            if (!isMobile())
                closeNav(location.pathname);
            document.querySelectorAll('.path-from-needle').forEach((x) => {
                x.classList.remove('path-from-needle');
            });
        }
    }, 1000);
    // Closes nav 
    const closeNav = (newUrl) => {
        if (newUrl) {
            const levelProps = {
                url: newUrl,
                orgUrl: newUrl[newUrl.length - 1] === '/' ? newUrl : `${newUrl}/`,
                renderedLevel: false,
                tree: findSubLevel(newUrl, navigationSettings),
                default: true
            };
            setLevel(levelProps);
        }
        document.body.style.overflow = '';
        if (!isMobile())
            setNavLevels([]);
        else
            toggleNav(false);
        document.querySelectorAll('.path-from-needle').forEach((x) => {
            x.classList.remove('path-from-needle');
        });
        if (props.dispatch)
            props.dispatch({ type: 'ApplicationStates/SetNavOpen', navOpen: false });
    };
    // Cancels nav closing during delay (func debouncedNav) if mouse comes over nav again
    const cancelCloseNav = () => {
        debouncedCloseNav.cancel();
    };
    // In mobile removes last level ("<"-button )
    const removeLastLevel = () => {
        setNavLevels((navLevels) => (navLevels.slice(0, -1)));
        setLevelRemoved(true);
    };
    // Opens next level of nav. Actually renders it all over again.
    const openLevel = (url, renderedLevel) => {
        const levelProps = {
            url: url,
            orgUrl: location.pathname[location.pathname.length - 1] === '/' ? location.pathname : `${location.pathname}/`,
            renderedLevel: renderedLevel,
            tree: level.tree,
            default: false
        };
        setLevel(levelProps);
        window.innerWidth > 859.99 ? window.scrollTo(0, 0) : document.querySelector('.main').scrollTo(0, 0);
    };
    // Reset menu to use whole navigationSetting item collection
    const backToMenu = () => {
        let strippedUrl = location.pathname;
        if (location.pathname[location.pathname.length - 1] === '/')
            strippedUrl = location.pathname.slice(0, location.pathname.lastIndexOf('/'));
        const levelProps = {
            url: strippedUrl.slice(0, strippedUrl.lastIndexOf('/') + 1),
            orgUrl: location.pathname[location.pathname.length - 1] === '/' ? location.pathname : `${location.pathname}/`,
            renderedLevel: false,
            tree: navigationSettings,
            default: false
        };
        setLevel(levelProps);
    };
    const scrollIconInit = (level) => {
        level = level ? level : document.querySelectorAll(`[data-level]`).length;
        for (let i = 0; i < level; i++) {
            document.querySelectorAll(`[data-level="${i + 1}"] .sub-tree`).forEach((x) => {
                x.scrollHeight > (window.innerHeight - document.querySelector('.mob-buttons').scrollHeight) ? x.parentElement.classList.add('scroll-icon-show') : x.parentElement.classList.remove('scroll-icon-show');
            });
        }
    };
    // Opens mobile nav. Uses backtomenu to reset partial navigation used in desktop mode.
    const OpenMobileNav = () => {
        backToMenu();
        document.body.style.overflow = 'hidden';
        if (props.dispatch)
            props.dispatch({ type: 'ApplicationStates/SetNavOpen', navOpen: true });
        adjustHeight();
        storeWindowDimensions();
    };
    const getFirstLevelNeedle = () => {
        if (props.currentLanguage === 'fi')
            return '/' + level.url.split('/')[1] + '/' + level.url.split('/')[2] + '/';
        return '/' + level.url.split('/')[1] + '/';
    };
    const mobileNavClasses = props.navOpen ? 'mobile-nav-open' : 'mobile-nav-closed';
    const storeWindowDimensions = () => {
        document.documentElement.style.setProperty('--window-height', `${Math.round(window.visualViewport.height * window.visualViewport.scale)}px`);
        document.documentElement.style.setProperty('--window-vvw', `${Math.round(window.visualViewport.width * window.visualViewport.scale)}px`);
    };
    const changeContentMinHeight = () => {
        if (document.querySelector('.left-navigation').clientHeight > document.getElementById('epi-page-container').clientHeight)
            props.setContentHeight(`${document.querySelector('.left-navigation').clientHeight}px`);
    };
    const onGestureEnd = () => {
        setTimeout(() => {
            storeWindowDimensions();
            if (window.visualViewport.scale * window.visualViewport.width > 859.99) {
                whenScrolling();
            }
        }, 500);
    };
    const mobileSearchButtonClickHandler = () => {
        window.location.pathname === searchPageUrl && closeNav();
    };
    (0, react_1.useEffect)(() => {
        storeWindowDimensions();
        window.addEventListener('resize', () => {
            storeWindowDimensions();
            if (window.innerWidth > 859.99) {
                closeNav();
                whenScrolling();
            }
            else {
                tree.current.style.height = '';
            }
        });
        if (window.innerWidth > 859.99) {
            whenScrolling();
        }
        else {
            document.querySelector('.main').addEventListener('scroll', whenScrolling);
        }
        window.addEventListener('scroll', whenScrolling);
        window.addEventListener('orientationchange', () => closeNav());
        window.addEventListener('gestureend', onGestureEnd); //for ios pinch zoom
        bottomSearchBtn.current.addEventListener('click', mobileSearchButtonClickHandler);
        changeContentMinHeight();
        return () => {
        };
    }, []);
    (0, react_1.useEffect)(() => {
        var _a;
        if (!props.navOpen) {
            (_a = document.querySelector('header .icon-menu_icon')) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, [props.navOpen]);
    (0, react_1.useEffect)(() => {
        buildNav(isMobile());
        adjustHeight();
        changeContentMinHeight();
    }, [level]);
    (0, react_1.useEffect)(() => {
        let isCancelled = false;
        if (!isMobile())
            setNavLevels([]);
        else
            toggleNav(false);
        Promise.allSettled([
            settingsService.getContainer('LayoutSettings'),
            settingsService.getContainer('LabelSettings'),
            settingsService.getContainer('Navigation'),
        ]).then((results) => {
            if (!isCancelled) {
                results[0].status === 'fulfilled' && setLayoutSettings(results[0].value);
                results[1].status === 'fulfilled' && setLabelSettings(results[1].value);
                if (results[2].status === 'fulfilled') {
                    setNavigationSettings(results[2].value);
                    const newProps = {
                        url: location.pathname[location.pathname.length - 1] === '/' ? location.pathname : `${location.pathname}/`,
                        orgUrl: location.pathname[location.pathname.length - 1] === '/' ? location.pathname : `${location.pathname}/`,
                        renderedLevel: level.renderedLevel,
                        tree: findSubLevel(location.pathname, results[2].value),
                        default: true
                    };
                    setLevel(newProps);
                }
            }
        });
        setMainpage(ctx.Language === 'fi' ? '/fi/' : '/');
        return () => { isCancelled = true; };
    }, [location.pathname]);
    (0, react_1.useEffect)(() => {
        var _a;
        let sectionHeading;
        if (navLevels.length > 0)
            sectionHeading = levelRemoved ? document.querySelector('[data-level]:nth-last-child(2) .section-heading div') : document.querySelector('[data-level]:last-child .section-heading div');
        else if (levelRemoved) {
            sectionHeading = document.querySelector('.level-1 .nav-item.active a');
            if (!sectionHeading)
                sectionHeading = document.querySelector('.level-1 .nav-item a');
            document.querySelectorAll('.path-from-needle').forEach((x) => {
                x.classList.remove('path-from-needle');
            });
        }
        if (sectionHeading) {
            sectionHeading.focus();
            setLevelRemoved(false);
        }
        else if (props.navOpen) {
            (_a = document.querySelector('.nav-tree ul li:not([aria-hidden]) a[href]')) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, [navLevels, levelRemoved]);
    const whenScrolling = () => {
        let srll = window.scrollY;
        if (window.innerWidth > 859.99) {
            adjustHeight();
            const naviSize = navi.current.scrollHeight;
            const windowSize = window.innerHeight;
            const pos = window.scrollY - (naviSize - windowSize);
            if (pos > 0) {
                navi.current.classList.remove('position-absolute');
                navi.current.classList.add('position-fixed');
                navi.current.style.bottom = '0';
            }
            else {
                navi.current.classList.remove('position-fixed');
                navi.current.classList.add('position-absolute');
                navi.current.style.bottom = '';
            }
        }
        else {
            document.querySelector('.main').scrollTop === 0 && scrollIconInit();
            srll = document.querySelector('.main').scrollTop;
        }
        if (srll !== 0)
            document.querySelectorAll('[data-level]').forEach((x) => {
                x.classList.remove('scroll-icon-show');
            });
    };
    const adjustHeight = () => {
        const nodes = tree.current.childNodes;
        let height = 0;
        if (nodes.length > 0) {
            nodes.forEach((node) => {
                height = node.children[0].scrollHeight > height ? node.children[0].scrollHeight : height;
            });
        }
        if (height > window.innerHeight)
            tree.current.style.height = `${height}px`;
        else
            tree.current.style.height = '';
        scrollIconInit();
    };
    const searchPageUrl = typeof (labelSettings.searchPageRedirectUrl) === 'string' ? labelSettings.searchPageRedirectUrl
        : (((_a = labelSettings.searchPageRedirectUrl) === null || _a === void 0 ? void 0 : _a.value) ? new URL(labelSettings.searchPageRedirectUrl.value).pathname : null);
    const siteLogo = ((_b = layoutSettings.siteLogo) === null || _b === void 0 ? void 0 : _b.value) ? layoutSettings.siteLogo.value : layoutSettings.siteLogo;
    let menuAriaLabel = ((_c = labelSettings.menuAriaLabel) === null || _c === void 0 ? void 0 : _c.value) || (typeof (labelSettings.menuAriaLabel) === 'string' ? labelSettings.menuAriaLabel : (_d = labelSettings.menuAriaLabel) === null || _d === void 0 ? void 0 : _d.value);
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Header_1.default, { isOpen: props.navOpen, openNav: OpenMobileNav, homehref: mainpage, settings: layoutSettings, siteLogo: siteLogo, labels: labelSettings }),
        react_1.default.createElement("div", { className: `${mobileNavClasses} main d-md-flex p-0 bg-white`, onMouseEnter: cancelCloseNav, onMouseLeave: debouncedCloseNav, onScroll: whenScrolling },
            react_1.default.createElement("nav", { ref: navi, className: "left-navigation row g-0", role: "navigation", "aria-label": menuAriaLabel },
                react_1.default.createElement("div", { className: 'mob-buttons position-absolute col-12 d-flex d-md-none align-items-center px-7 py-8' },
                    react_1.default.createElement("button", { style: { width: '2rem' }, type: "button", className: `icon-right-arrow p-0 ${navLevels.length === 0 ? 'd-none' : ''}`, onClick: () => removeLastLevel() },
                        react_1.default.createElement("span", { className: 'visually-hidden' },
                            react_1.default.createElement(spa_core_1.Components.Property, { iContent: labelSettings, field: 'backText' }))),
                    navLevels.length === 0 &&
                        react_1.default.createElement("div", { className: 'pt-0 pt-md-7 text-center logo-content position-absolute start-0 end-0 me-0' },
                            react_1.default.createElement("a", { href: mainpage, target: '_self', className: 'd-block mb-md-6 logo' },
                                react_1.default.createElement(spa_core_1.Components.EpiserverContent, { contentLink: siteLogo, expandedValue: siteLogo.expanded }),
                                react_1.default.createElement("span", { className: 'visually-hidden' },
                                    react_1.default.createElement(spa_core_1.Components.Property, { iContent: layoutSettings, field: 'logoAccessibilityHint' })))),
                    react_1.default.createElement("button", { style: { width: '2rem' }, className: 'icon-close ms-auto p-0', onClick: () => toggleNav(false) },
                        react_1.default.createElement("span", { className: 'visually-hidden' },
                            react_1.default.createElement(spa_core_1.Components.Property, { iContent: labelSettings, field: 'closeText' })))),
                react_1.default.createElement("div", { ref: tree, className: 'nav-tree position-relative' },
                    react_1.default.createElement("div", { ref: level1, className: `col level-1 ${navLevels.length > 0 ? 'd-none' : ''} d-md-block position-absolute` },
                        react_1.default.createElement("div", { className: 'row flex-column g-0 flex-nowrap minh-100 mobile-minh' },
                            react_1.default.createElement("div", { className: 'd-none d-md-block pt-0 pt-md-7 text-center logo-content' },
                                react_1.default.createElement("a", { href: mainpage, target: '_self', className: 'd-block mb-md-6 logo' },
                                    react_1.default.createElement(spa_core_1.Components.EpiserverContent, { contentLink: siteLogo, expandedValue: siteLogo.expanded }),
                                    react_1.default.createElement("span", { className: 'visually-hidden' },
                                        react_1.default.createElement(spa_core_1.Components.Property, { iContent: layoutSettings, field: 'logoAccessibilityHint' }))),
                                react_1.default.createElement("p", { className: 'company-info mx-auto mb-0 mb-md-3' },
                                    react_1.default.createElement(spa_core_1.Components.Property, { iContent: layoutSettings, field: 'companyDesc' }))),
                            react_1.default.createElement("div", { className: `mb-5 mb-md-0 ${!((_e = level.tree) === null || _e === void 0 ? void 0 : _e.isSubMenu) && 'main'} w-100` },
                                react_1.default.createElement(NavigationTree_1.default, { labels: labelSettings, closeNav: closeNav, openLevel: openLevel, navigationTree: ((_f = level === null || level === void 0 ? void 0 : level.tree) === null || _f === void 0 ? void 0 : _f.items) || ((_g = level === null || level === void 0 ? void 0 : level.tree) === null || _g === void 0 ? void 0 : _g.subItems), showBackToMenu: (_h = level.tree) === null || _h === void 0 ? void 0 : _h.isSubMenu, backToMenu: backToMenu, navigationLevelAsNum: 1, maxLevelsInMobile: maxLevelsInMobile(), currentUrl: level.orgUrl, needle: getFirstLevelNeedle(), adjustHeight: adjustHeight, removeLastLevel: removeLastLevel }),
                                react_1.default.createElement(NavigationSearch_1.default, { labels: labelSettings, inHeader: false })),
                            react_1.default.createElement("div", { className: 'bottom-area px-7 px-md-0 py-3 py-md-7 mt-auto' },
                                react_1.default.createElement("div", { className: 'row g-5 g-md-0' },
                                    react_1.default.createElement("div", { className: 'col-6 d-md-none d-flex align-items-center' },
                                        react_1.default.createElement("a", { href: searchPageUrl, ref: bottomSearchBtn, className: 'border-0 px-3 px-md-6 py-3 py-md-2 nav-button text-uppercase small-bold d-flex align-items-center' },
                                            react_1.default.createElement("span", { className: 'icon-search fw-bold pe-5', "aria-hidden": true }),
                                            react_1.default.createElement(spa_core_1.Components.Property, { iContent: labelSettings, field: 'searchLabel' }))),
                                    react_1.default.createElement(LanguageSelector_1.default, { labels: labelSettings })),
                                react_1.default.createElement(Shareticker_1.default, { layoutSettings: layoutSettings, bgcolorClass: 'ticker-white', desktopVersion: true })))),
                    react_1.default.createElement(framer_motion_1.AnimatePresence, null, navLevels)))));
};
exports.Navigation = Navigation;
exports.ConnectedNavigation = (0, react_redux_1.connect)((state, ownProps) => {
    const propsFromState = state.OptiContentCloud || {};
    const propsFromAppState = state.ApplicationStates || {};
    return Object.assign(Object.assign(Object.assign({}, ownProps), propsFromState), propsFromAppState);
})(exports.Navigation);
exports.default = exports.ConnectedNavigation;
